module.exports = __webpack_public_path__ + "img/divider.f0d3567e.svg";